// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__2YPaj","requiredAsterisk":"Info_requiredAsterisk__3K9wU"};